import { render } from "./ShareDropdown.vue?vue&type=template&id=f562fffc&scoped=true&ts=true"
import script from "./ShareDropdown.vue?vue&type=script&lang=ts"
export * from "./ShareDropdown.vue?vue&type=script&lang=ts"

import "./ShareDropdown.vue?vue&type=style&index=0&id=f562fffc&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f562fffc"]])

export default __exports__